import Base from './base'

export default {
  Create: (data: any): Promise<any> => {
    return Base('/general/v1', 60000).post(`/admin/uploads`, data)
  }
}
